import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { l } from '@manychat/manyui'

import { FOLLOW_REPLY_CHANNEL } from 'apps/followReply/constants'
import { FollowReplyState } from 'apps/followReply/interfaces'
import { getChannelState, NAMESPACE } from 'apps/followReply/store/constants'
import { alert } from 'common/core'
import { openInstagramChangeConnectionModal } from 'common/core/actions/uiActions'
import { handleError } from 'shared/api/lib/errors/handlers'
import { followReplyApi } from 'shared/api/requests/followReply'
import { isFollowReplyNeedToUpdatePermissionsError } from 'shared/api/requests/followReply/guards'
import { createAsyncAction } from 'shared/lib/redux'

export const toggleFlow = createAsyncAction(
  `${NAMESPACE}/toggleFlow`,
  async (enabled: boolean, { dispatch }) => {
    try {
      const updatedFlow = await followReplyApi.switch({
        body: {
          enabled: enabled ? 1 : 0,
        },
      })

      if (updatedFlow.data.enabled) {
        alert(l.translate('Follow Private reply activated'), 'success')
      } else {
        alert(l.translate('Follow Private reply deactivated'))
      }

      return updatedFlow.data
    } catch (error) {
      handleError(error, (businessError) => {
        if (isFollowReplyNeedToUpdatePermissionsError(businessError)) {
          dispatch(openInstagramChangeConnectionModal(null, false))
          businessError.handle()
        }
      })
      return
    }
  },
)

export const toggleFlowReducer = (builder: ActionReducerMapBuilder<FollowReplyState>) => {
  builder.addCase(toggleFlow.fulfilled, (state, action) => {
    const data = action.payload
    state[FOLLOW_REPLY_CHANNEL] = getChannelState(data)
  })
}
